import Vue from "vue";
import Router from "vue-router";
import Dashboard from "./views/Dashboard.vue";
import Calendar from "./views/Calendar.vue";
import Match from "./views/Match.vue";
import Report from "./views/Report.vue";
import SubscriptionsReport from "./views/SubscriptionsReport.vue";
import Tribune from "./views/Admin/Tribunes.vue";
import Subscriptions from "./views/Subscriptions.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "dashboard",
      component: Dashboard
    },
    {
      path: "/calendar",
      name: "agenda",
      component: Calendar
    },
    {
      path: "/admin/tribunes",
      name: "tribune",
      component: Tribune
    },
    {
      path: "/subscriptions",
      name: "subscriptions",
      component: Subscriptions
    },
    {
      path: "/match/:id",
      name: "match",
      component: Match
    },
    {
      path: "/report/:id",
      name: "report",
      component: Report
    },
    {
      path: "/subscription-report",
      name: "subscriptionsReport",
      component: SubscriptionsReport
    }
  ]
});
